import React from 'react';
import { Target, Users, Rocket, Award } from 'lucide-react';

const AboutSection = () => {
  const values = [
    {
      icon: Target,
      title: 'Our Mission',
      description: 'To revolutionize industrial inspection through intelligent autonomous robotics.',
    },
    {
      icon: Rocket,
      title: 'Innovation',
      description: 'Pushing boundaries with cutting-edge AI and robotics technology.',
    },
    {
      icon: Users,
      title: 'Collaboration',
      description: 'Working closely with industry partners to solve real-world challenges.',
    },
    {
      icon: Award,
      title: 'Excellence',
      description: 'Committed to delivering uncompromising quality and reliability.',
    },
  ];

  return (
    <section id="about" className="py-24 px-6 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full blur-3xl opacity-10" style={{ background: '#35474B' }} />

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground-primary">About Vinayak Robotics</h2>
          <p className="text-lg max-w-2xl mx-auto text-foreground-secondary">
            Building the future of autonomous industrial inspection
          </p>
        </div>

        {/* Main Content */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          {/* Image */}
          <div className="glass-frosted rounded-3xl overflow-hidden glow-subtle">
            <img
              src="https://images.pexels.com/photos/35383624/pexels-photo-35383624.jpeg"
              alt="Our Team"
              className="w-full h-full object-cover min-h-[400px]"
            />
          </div>

          {/* Content */}
          <div className="flex flex-col justify-center space-y-6">
            <h3 className="text-3xl font-bold text-foreground-primary">Who We Are</h3>
            <p className="text-lg leading-relaxed text-foreground-secondary">
              Vinayak Robotics specializes in creating intelligent, field-ready machines for extreme industrial
              environments. From our <span style={{ color: '#F97316', fontWeight: 'bold' }}>Vulcan Series</span> autonomous
              inspection robots to our <span style={{ color: '#F97316', fontWeight: 'bold' }}>Astra Series</span> precision
              measurement devices, we build technology that works where it matters most.
            </p>
            <p className="text-lg leading-relaxed text-foreground-secondary">
              We merge rugged engineering with advanced autonomy to deliver solutions that enhance safety, accuracy,
              and efficiency across critical infrastructure industries.
            </p>
            <div className="glass-effect rounded-xl p-6" style={{ borderColor: 'rgba(249, 115, 22, 0.3)', borderWidth: '1px' }}>
              <p className="text-xl font-semibold" style={{ color: '#F97316' }}>
                "Intelligent Machines. Infinite Possibilities."
              </p>
              <p className="text-sm mt-2 text-foreground-secondary">
                Our vision for the future of industrial automation
              </p>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-6">
          {values.map((value, index) => (
            <div key={index} className="flex items-start gap-3">
              <value.icon size={20} style={{ color: '#F97316', marginTop: '3px' }} className="flex-shrink-0" />
              <div>
                <h3 className="text-sm font-bold text-foreground-primary">{value.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-secondary mt-1">{value.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;